// import Legend from '@arcgis/core/widgets/Legend';
import Home from '@arcgis/core/widgets/Home';
import Zoom from '@arcgis/core/widgets/Zoom';
import Expand from '@arcgis/core/widgets/Expand';
import BasemapToggle from '@arcgis/core/widgets/BasemapToggle';
import SearchPanel from './components/SearchPanel/SearchPanel';
import ReactDOM from 'react-dom';
import UglyLegend from './components/UglyLegend';

async function setupWidgets({
  map,
  view,
  countyBorderLayer,
  countyBorderLayerView,
}) {
  const homeWidget = new Home({ view });
  view.ui.add(homeWidget, 'top-left');

  const zoom = new Zoom({ view });
  view.ui.add(zoom, 'top-left');

  const basemapToggle = new BasemapToggle({
    view,
    nextBasemap: 'satellite',
    visibleElements: {
      title: true,
    },
  });
  view.ui.add(basemapToggle, 'top-left');

  const legendDiv = document.createElement('div');
  ReactDOM.render(<UglyLegend />, legendDiv);

  const legendExpand = new Expand({
    expanded: true,
    mode: 'floating',
    content: legendDiv,
  });
  view.ui.add(legendExpand, 'bottom-right');

  // const legend = new Legend({ view });
  // view.ui.add(legend, 'bottom-left');

  const searchDiv = document.createElement('div');
  ReactDOM.render(
    <SearchPanel
      countyBorderLayer={countyBorderLayer}
      countyBorderLayerView={countyBorderLayerView}
      view={view}
      map={map}
    />,
    searchDiv
  );
  const expand = new Expand({
    expanded: true,
    mode: 'floating',
    content: searchDiv,
  });
  view.ui.add(expand, 'top-right');
}

export default setupWidgets;
